
export default function Button({text, ctaURL, target="_self", variant="btn-primary"}) {

    /*
        variant => btn-danger, btn-primary, btn-secondary
     */

    function handleClick() {
        if (typeof window.gtag === "function") {
            window.gtag("event", "cta_click", {
                cta_text: text,
                cta_url: ctaURL,
                cta_variant: variant,
                page_path: window.location.pathname,
            });
        }
    }

    return (
        <div className="col-auto cta-link my-2">
            <a href={ctaURL} className={`${variant} btn`} target={target} rel="noopener noreferrer" onClick={handleClick}>
                <div className="font-semibold">
                    {text}
                </div>
            </a>
        </div>
    )
}